import { h, Component, createRef } from "preact"
import { SelectionButtons } from "./buttons"
import { GoogleMap } from "./google-map"
import { Slider } from "./slider"
import { breakpoints } from "../../util/breakpoints"

export class FarmersApp extends Component {
  currentBreakpoint = breakpoints()
  farmersRef = createRef()

  getRegionForFarmerId = (id) => {
    const farmer = this.props.markers.farmers.find((o) => o.id === id)
    return farmer
      ? this.props.regions.find((r) => r.codes.includes(farmer.iso2_code))
      : false
  }

  getInitialRegionId = () => {
    const { id, type } = this.props.activeOverride
    let region = this.props.regions[0]
    if (type === "farmers" && id) {
      region = this.getRegionForFarmerId(id) || region
    }
    return region.id
  }

  getMarkers = (region = false) => {
    const _region = region || this.getInitialRegionId()
    return this.props.markers.farmers.filter((o) => {
      return this.props.regions
        .find((r) => r.id === _region)
        .codes.includes(o.iso2_code)
    })
  }

  getInitialActiveElement = (markers = false) => {
    const { id, type } = this.props.activeOverride
    let element
    if (
      type === "farmers" &&
      this.props.markers.farmers.some((o) => o.id === id)
    ) {
      element = id
    } else {
      const _markers = markers || this.getMarkers()
      const initialElement =
        _markers.length > 0
          ? _markers[(_markers.length * Math.random()) | 0].id
          : false

      element = initialElement
    }
    return element
  }

  getSliderData = (id) => {
    this.setState({ sliderData: false })
    this.props
      .getDetailData(id, "farmers")
      .then((_data) => this.setState({ sliderData: _data }))
  }

  activateElement = (id) => {
    this.setState({ activeElement: id })
    this.getSliderData(id)
  }

  activateRegion = (region, _) => {
    const newMarkers = this.getMarkers(region)
    this.setState({ activeRegion: region, markers: newMarkers })
    this.activateElement(this.getInitialActiveElement(newMarkers))
  }

  openModalFunction = (activeElement) => {
    this.props.openModalFunction(
      activeElement || this.state.activeElement,
      "farmers",
    )
  }

  activateAndOpenModalFunction = (activeElement, _type) => {
    this.activateElement(activeElement)
    if (this.currentBreakpoint !== "large")
      this.props.openModalFunction(activeElement, "farmers")
  }

  state = {
    activeElement: this.getInitialActiveElement(),
    activeRegion: this.getInitialRegionId(),
    markers: this.getMarkers(),
    sliderData: false,
  }

  componentWillReceiveProps({ activeOverride }) {
    const { id, type } = activeOverride
    if (id != this.state.activeElement && type === "farmers") {
      const region = this.getRegionForFarmerId(id)
      this.activateAndOpenModalFunction(id)
      this.setState({
        activeRegion: region.id,
        markers: this.getMarkers(region.id),
      })
    }
  }

  componentDidMount() {
    const { id, type } = this.props.activeOverride
    if (id && type === "farmers") {
      this.activateAndOpenModalFunction(id)
      this.farmersRef.current.scrollIntoView({ behavior: "smooth" })
    }
    this.getSliderData(this.state.activeElement)

    window.addEventListener(
      "resize",
      () => {
        if (breakpoints() != this.currentBreakpoint) {
          this.currentBreakpoint = breakpoints()
          this.forceUpdate()
        }
      },
      true,
    )
  }

  render(props, state) {
    return (
      <div
        id="farmers-app"
        class="columns margin--bottom farmers-section farmers"
        ref={this.farmersRef}
      >
        <div class="farmers__teaser">
          <div class="farmers__teaser-item">
            <span>{props.farmers.heading}</span>
            {this.currentBreakpoint !== "large" && props.children}
            <p>{props.farmers.text}</p>
            <Slider
              elements={state.markers}
              active={state.activeElement}
              type="farmers"
              activate={this.activateElement}
              data={state.sliderData}
              openModalFunction={this.openModalFunction}
              translations={props.translations}
              fakeSlide={[props.farmers.heading, props.farmers.mobile_text]}
            />
          </div>
        </div>
        <div class="farmers__map-and-buttons">
          {this.currentBreakpoint === "large" && (
            <SelectionButtons
              buttons={props.regions}
              active={state.activeRegion}
              activate={this.activateRegion}
            />
          )}
          <div class="farmers__map">
            {this.currentBreakpoint === "large" && props.children}
            <GoogleMap
              actives={[{ id: state.activeElement, type: "farmers" }]}
              class={"farmers"}
              markers={props.markers.farmers}
              visibleMarkers={state.markers}
              activate={this.activateAndOpenModalFunction}
              scope={
                props.regions.find((r) => r.id === state.activeRegion).scope
              }
            />
          </div>
          {this.currentBreakpoint !== "large" && (
            <SelectionButtons
              buttons={props.regions}
              active={state.activeRegion}
              activate={this.activateRegion}
            />
          )}
        </div>
      </div>
    )
  }
}
